import { useTranslation } from 'react-i18next';
import { Select } from 'components/Select';
import type { ReturnReason } from 'components/MerchantTrackingWidget/components/ReturnRequestModal/interfaces';
import { useReasonForReturnInput } from '../hooks';

interface ReasonForReturnInputProps {
  onChange: (value: any) => void;
  value: ReturnReason;
  errorMessage: string;
}

export const ReasonForReturnInput = ({
  onChange,
  errorMessage,
  value,
}: ReasonForReturnInputProps) => {
  const { t } = useTranslation();
  const { selectOptions } = useReasonForReturnInput();
  const selectPlaceholder = `${t('RETURN_REASON_FOR_RETURNING')}*`;

  return (
    <Select
      value={value}
      options={selectOptions}
      onSelect={onChange}
      placeholder={selectPlaceholder}
      helpText={errorMessage}
      hasError={!!errorMessage}
      required
      aria-label={t('RETURN_REASON_FOR_RETURNING')}
    />
  );
};
